import { useHistory } from 'react-router-dom';
import { useStore } from 'effector-react';
import { Tooltip } from '@mui/material';
import { $user } from '@features/common';
import * as Styled from './styled';

export const ProfileLink = () => {
  const { user_fullname, user_email, user_id } = useStore($user);
  const history = useHistory();

  const userIdText = `USER_ID: ${user_id}`;
  const profileText = user_fullname || user_email || userIdText;

  return (
    <Tooltip title={userIdText}>
      <Styled.Button onClick={() => history.push('/profile')} color="inherit">
        {profileText}
      </Styled.Button>
    </Tooltip>
  );
};
